import { mediaQueryUp } from 'components/utils/breakpoint'
import Modal from 'LuxKit/Modal/Modal'
import SegmentedOptionsGroup from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'
import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'
import { rem } from 'polished'
import { useCallback, useState } from 'react'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import NavBarLanguageItems from './NavBarLanguageItems'
import NavBarRegionItems from './NavBarRegionItems'

const SegmentedOptionsWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const Content = styled.div`
  padding-top: ${rem(16)};
`

export const NavBarCurrencyLanguageDialog = styled(Modal)`
  ${mediaQueryUp.tablet} {
    &&& {
      --nav-bar-currency-language-dialog-size: min(
        calc(100vw - ${rem(40)}),
        calc(100dvh - ${rem(40)}),
        ${rem(560)}
      );

      width: var(--nav-bar-currency-language-dialog-size) !important;
      max-width: var(--nav-bar-currency-language-dialog-size) !important;
      height: var(--nav-bar-currency-language-dialog-size) !important;
      max-height: var(--nav-bar-currency-language-dialog-size) !important;
    }
  }
`

interface Props {
  onSelect?: React.MouseEventHandler<HTMLButtonElement>
  showLanguageTab: boolean
}

function NavBarCurrencyLanguageModal(props: Props) {
  const { onSelect, showLanguageTab } = props
  const [activeTab, setActiveTab] = useState<'currency' | 'language'>('currency')
  const handleValueChange = useCallback((value: 'currency' | 'language') => {
    setActiveTab(value)
  }, [])

  return <>
    {showLanguageTab && <SegmentedOptionsWrapper>
      <SegmentedOptionsGroup<'currency' | 'language'>
        inputsName="nav-bar-currency-language-tab"
        onValueChange={handleValueChange}
      >
        <SegmentedOption
          value="currency"
          checked={activeTab === 'currency'}
          title={
            <FormattedMessage
              id="5IzESyiJhZD7FXx2DaTM"
              defaultMessage="Region & Currency"
              description="Tab label for region and currency selection in the language and currency modal"
            />
          }
        />
        <SegmentedOption
          value="language"
          checked={activeTab === 'language'}
          title={
            <FormattedMessage
              id="_eRiayfEzUbUZ4Bbpv7r"
              defaultMessage="Language"
              description="Tab label for language selection in the language and currency modal"
            />
          }
        />
      </SegmentedOptionsGroup>
    </SegmentedOptionsWrapper>}
    <Content>
      {activeTab === 'currency' && <NavBarRegionItems onRegionSelect={onSelect} />}
      {activeTab === 'language' && showLanguageTab && <NavBarLanguageItems onLanguageSelect={onSelect} />}
    </Content>
  </>
}

export default React.memo(NavBarCurrencyLanguageModal)
